import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import Alert from "../alert";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import EditButtonModal from "../../routes/horarios/actions/edit";
import DeleteButtonModal from "../../routes/horarios/actions/delete";

export default function TablaPrograms({
  programs,
  setPrograms,
  programsData,
  validateErrors,
  deleteProgram,
  updateProgram,
  id_day,
  day,
  refreshFunction,
}) {
  const [progamsArray, setProgramsArray] = useState([]);
  const [snack, setSnack] = useState({
    open: false,
    message: "Error",
    type: "warning",
  });

  useEffect(() => {
    setProgramsArray(programs);
  }, [programs]);

  const onDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    const items = [...progamsArray];
    const [removed] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, removed);
    setProgramsArray(items);
    setPrograms(items);
  };

  const dayPretty = ({ number }) => {
    let fullHour = "";
    if (Number.isInteger(number)) {
      number = number.toString();
      fullHour = `${number.length === 1 ? `0${number}` : number}:00`;
    } else {
      number = number.toString();
      const split = number.split(".");
      fullHour = `${split[0].length === 1 ? `0${split[0]}` : split[0]}:${
        split[1].length === 1 ? `${split[1]}0` : split[1]
      }`;
    }

    fullHour += "hrs";
    return fullHour;
  };

  const getProgramName = (program_id) => {
    const filter = programsData.filter((program) => program._id === program_id);
    //console.log("filter", filter)
    return filter[0].name;
  };

  return (
    <Card>
      {snack.open && <Alert message={snack.message} Popen={snack.open} type={"warning"} />}

      <CardContent>
        {progamsArray !== undefined && progamsArray.length !== 0 ? (
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppabl">
              {(droppableProvided) => (
                <div
                  className="droppabl"
                  {...droppableProvided.droppableProps}
                  ref={droppableProvided.innerRef}
                >
                  {progamsArray.map((program, index) => (
                    <Draggable
                      key={`${program.program_id}-${index}`}
                      draggableId={`${program.program_id}-${index}`}
                      index={index}
                    >
                      {(draggableProvider) => (
                        <Card
                          sx={{ m: 2, borderRadius: 1, boxShadow: 10 }}
                          {...draggableProvider.draggableProps}
                          ref={draggableProvider.innerRef}
                          {...draggableProvider.dragHandleProps}
                        >
                          <CardContent key={index}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={8}>
                                <Grid container spacing={2}>
                                  {/* <Grid item xs={12} md={4}>
                                  <img src="https://crop-platform-static.cdn.mdstrm.com/show/images/602140ecd1277a077ef81b34_61f4678958b99969a9a8de35_1643756840911.png?w=440&h=440&fit=crop&crop=entropy&crop=faces&q=80&auto=format" style={{ width: "100%" }}/>
                                </Grid> */}
                                  <Grid item xs={12}>
                                    <Typography
                                      variant="h6"
                                      color={"gb(57, 56, 56)"}
                                      sx={{ fontSize: 19 }}
                                    >
                                      {getProgramName(program.program_id)}
                                    </Typography>
                                    <Typography variant="body1" sx={{ fontSize: 15 }}>
                                      {dayPretty({ number: program.time_start })} -{" "}
                                      {dayPretty({ number: program.time_end })}{" "}
                                    </Typography>
                                    {validateErrors.length > 0 && (
                                      <Typography
                                        variant="body1"
                                        sx={{ fontSize: 14, color: "red" }}
                                      >
                                        {validateErrors.map((obj) => {
                                          if (obj.position === index) {
                                            return (
                                              <ul>
                                                {obj.error_times && <li>{obj.error_times}</li>}
                                                {obj.timeEndPreviusEmition && (
                                                  <li>{obj.timeEndPreviusEmition}</li>
                                                )}
                                              </ul>
                                            );
                                          }
                                        })}
                                      </Typography>
                                    )}
                                    {/* <Typography dir="rtl">Orden: {index + 1}</Typography> */}
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <Box sx={{ display: "flex", justifyContent: "end" }}>
                                  <EditButtonModal
                                    program={program}
                                    editProgram={updateProgram}
                                    position={index}
                                  />
                                  <DeleteButtonModal
                                    program={program}
                                    deleteProgram={deleteProgram}
                                    position={index}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      )}
                    </Draggable>
                  ))}
                  {droppableProvided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        ) : (
          <div>No hay emisiones registradas</div>
        )}
      </CardContent>
    </Card>
  );
}
